import _ from 'lodash';
import { reactive } from 'vue';
import type { IResultChart } from '@/components/analysis/charts'
import { E_ANALYSIS_CHART, resultChartsTechObjectives } from '@/components/analysis/charts'

export function useTechBgObjectives() {
    const charts = reactive<IResultChart[]>(resultChartsTechObjectives);

    function configTaskFunc(config: any) {
        return () => Promise.resolve(config);
    }

    function colorFunc(chartType: E_ANALYSIS_CHART) {
        const colorMap: {[key in E_ANALYSIS_CHART]?: string} = {
            [E_ANALYSIS_CHART.PATENT_TRENDS_BAR]: '#1976D2',
            [E_ANALYSIS_CHART.PAPER_TRENDS_LINE]: '#1976D2',
        }
        return (arr: any[]) => {
            if (_.includes(_.keys(colorMap), chartType)) {
                return _.map(arr, item => ({
                    ...item,
                    color: colorMap[chartType],
                }));
            }
            return arr;
        }
    }

    return {
        charts,
        configTaskFunc,
        colorFunc,
    }
}
